
import "/app/src/components/ai-button/index.module.less?modules";
export default {"aiButtonLink": `aiButtonLink-Fp-o_tX4`,"aiButton": `aiButton-7HiWlBX4`,"aiButtonIconOnly": `aiButtonIconOnly-ul4jSR5r`,"aiButtonSmall": `aiButtonSmall-d-K69L7C`,"ant-btn-loading": `ant-btn-loading-4dKMQ_lp`,"aiButtonLarge": `aiButtonLarge-2BLwn-bY`}
